import { ReactNode } from "react";

import { Heading } from "@components/common/ui/Heading";
import { Text } from "@components/common/ui/Text";

import * as S from "./styles";
import { Tooltip } from "@kirvanobr/tooltip";

import InfoCircle from "@assets/icons/InfoCircle";
interface CardProps {
  variant?: "success" | "info" | "warning" | "default" | "disabled";
  centered?: boolean;
  title?: string;
  value?: string;
  descriptionTitle?: string;
  descriptionValue?: string;
  tooltip?: string;
  tooltipDirection?: "top" | "right" | "bottom" | "left";
}
export function Card({
  variant,
  title,
  value,
  descriptionTitle,
  descriptionValue,
  children,
  tooltip,
  tooltipDirection = "right",
  ...props
}: CardProps & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <S.Container variant={variant} {...props}>
      {children ?? (
        <>
          <S.Text>
            <S.Title>
              <Heading weight={"bold"} size={"small"}>
                {title}
              </Heading>
              {tooltip && <Tooltip content={tooltip} />}
            </S.Title>

            {descriptionTitle && (
              <Text weight={"regular"} size={"small"}>
                {descriptionTitle}
              </Text>
            )}
          </S.Text>

          <S.Text>
            <Heading weight={"medium"} size={"large-2"} className="title">
              {value}
            </Heading>

            {descriptionValue && (
              <Text weight={"medium"} size={"small"} className="title description">
                {descriptionValue}
              </Text>
            )}
          </S.Text>
        </>
      )}
    </S.Container>
  );
}
